import TableActionsMenu from "@/components/data/table/TableActionsMenu"
import { DropdownMenuItem } from "@/components/ui/dropdown-menu"
import { toast } from "@/lib/toast"
import { CredentialType } from "@/stores/credential.store"
import { store } from "@/stores/stores"
import { Link } from "react-router"

interface CredentialRowProps {
  credential: CredentialType
  type: string
}

function CredentialRow(props: CredentialRowProps) {
  const credentialMeta = store.credential.credentialsMeta.record[props.type]

  return (
    <Link
      to={{ hash: `settings/credentials/${props.credential.id}/connection/${props.type}` }}
      key={props.credential.id}
      className="hover:border-transparent hover:bg-card-hover transition-all duration-150 rounded-xl flex items-center p-2 px-3 gap-4"
    >
      <div className="bg-card-hover rounded-full p-2.5" 
      style={{
        backgroundColor: credentialMeta?.color,
      }}
      >
        <img src={credentialMeta?.image_src} className="size-5.5 object-contain" />
      </div>

      <div className="flex-1 flex items-center justify-between">
        <div className="flex flex-col leading-4">
          <span className="text-sm font-medium">{props.credential.name}</span>
          <span className="text-xs text-secondary">{credentialMeta?.label}</span>
        </div>
        <TableActionsMenu
          items={
            <>
              <Link to={{ hash: `settings/credentials/${props.credential.id}/connection/${props.type}` }}>
                <DropdownMenuItem>
                  <IconHugeiconsEdit01 className="size-5" />
                  Edit
                </DropdownMenuItem>
              </Link>
              <DropdownMenuItem
                onClick={(e) => {
                  e.stopPropagation()
                  store.app.actions.openConfirmModal({
                    title: `Delete`,
                    children: <span>Are you sure you want to delete the credential {props.credential.name}?</span>,
                    danger: true,
                    onConfirm() {
                      return store.credential.actions.delete(props.credential.id).then(() => {
                        toast.success(`Credential ${props.credential.name} deleted`)
                      })
                    },
                  })
                }}
              >
                <IconHugeiconsDelete03 className="size-5" />
                Delete
              </DropdownMenuItem>
            </>
          }
        />
      </div>
    </Link>
  )
}

export default CredentialRow
